import { useTranslation } from 'react-i18next';
import { SsoIntegrationWarningKeyEnum } from 'graphql-common';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';

interface Props {
  warningKey?: SsoIntegrationWarningKeyEnum | null;
  onEdit: () => void;
}

export default function SsoWarningBanner({ warningKey, onEdit }: Props) {
  const { t } = useTranslation();

  if (!warningKey) return null;

  const warningTextMap: Record<SsoIntegrationWarningKeyEnum, string> = {
    [SsoIntegrationWarningKeyEnum.NoVerifiedDomains]: t(
      'no-verified-domains-warning',
    ),
    [SsoIntegrationWarningKeyEnum.SomeDomainsNotVerified]: t(
      'some-domains-not-verified-warning',
    ),
  };

  const text = warningTextMap[warningKey];

  return (
    <SupportiveMessage
      color={SupportiveMessageColor.Yellow}
      type={SupportiveMessageType.FilledWithLeftBorder}
      text={text}
      leftIconSymbolsOutlined
      actions={
        <Button
          buttonText={t('edit')}
          buttonType={ButtonTypes.primaryFilled}
          buttonSize={ButtonSizes.small}
          onClick={onEdit}
        />
      }
    />
  );
}
